import { Box, Tab, Tabs, Typography } from "@mui/material";
import {
  getDeliveryTypes,
  getFrequnceyList,
  getOrderDetailsById,
  printGreetingMessage,
  orderMailSend,
  unsetFraudOrder,
  transferToDifferentStore,
  updateOnfleetOrder,
  updateBurqOrder,
} from "api/order";
import OrderError from "Components/OrderError/OrderError";
import { useOrder } from "Context/OrderContext/useOrder";
import { convertDateTime } from "Helpers/date";
import { formatInternalNoteAuthor } from "Helpers/internalNote";
import { openPrintMessage } from "Helpers/openPrintMessage";
import { isRefundSupported } from "Helpers/refundSupport";
import React, { useContext, useEffect, useMemo, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import defaultSignature from "../../../Assets/images/default-signature.svg";
import CardInfoSaved from "../../../Components/Card/CardInfoSaved";
import RadioBox from "../../../Components/FormControl/RadioBox/RadioBox";
import Text from "../../../Components/FormControl/Text/Text";
import TextArea from "../../../Components/FormControl/TextArea/TextArea";
import GreetingCard from "../../../Components/GreetingCard/GreetingCard";
import Header from "../../../Components/Header/Header";
import Internotes from "../../../Components/Internotes/InternalNoteView";
import styles from "../../../Components/NewOrder/index.module.scss";
import OrderSummery from "../../../Components/NewOrder/OrderSummery";
import OrderReason from "../../../Components/OrderReason/OrderReason";
import OrderProducts from "../../../Components/Products/OrderProducts";
import VideoMessage from "../../../Components/VideoMessage/VideoMessage";
import BillingForm from "../../../Components/ViewOrder/BillingForm";
import CoustumerForm from "../../../Components/ViewOrder/CoustumerForm";
import { downloadOrderReceiptPdf } from "../../../Components/ViewOrder/OrderReceipt/createOrderReceiptPdf";
import RecipentForm from "../../../Components/ViewOrder/RecipentForm";
import TotalBox from "../../../Components/ViewOrder/TotalBox";
import {
  BRAINTREE_STORE,
  ONDEMAND_TRANSFER_DELIVERY_TYPE_IDS,
  ORDER_SOURCE,
  ORDER_STATUS,
  PAYMENT_METHODS,
  PAYMENT_METHOD_DETAIL,
  PAYMENT_TYPE,
} from "../../../Helpers/Constants";
import { checkValidEmailId, formatUsPhone } from "../../../Hooks/commanUtility";
import TransferToDifferentStore from "Components/Modal/TransferToDifferentStore";
import { AppContext } from "./../../../Context/AppContext";
import { MODULES } from "./../../../Helpers/Constants";
import { getAccessByModuleName } from "./../../../Routes/Routes";

import EmailReSendMail from "../../../Components/Modal/EmailReSend/EmailReSend";
import { OrderConfigContext } from "Context/OrderConfigContext";
import ChangetoOnDemand from "Components/Modal/ChangetoOnDemand";
import TransferToOnFleetModal from "Components/Modal/TransferToOnfleet";
import Confirmation from "Components/Modal/Confirmation/Confirmation";
import SegmentBadge from "../../../Components/SegmentBadge/SegmentBadge";

const ViewOrder = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [orderDetails, setOrderDetails] = useState({});
  const [deliveryTypesList, setDeliveryTypesList] = useState([]);
  const [frequencyList, setFrequencyList] = useState([]);
  const [showAddModal, setShowAddModal] = useState(false);
  const [resendEmailType, setResendEmailType] = useState("confirmation");
  const [submitStatus, setSubmitStatus] = useState(false);
  const [isDownloadingReceipt, setIsDownloadingReceipt] = useState(false);
  const [transferToDifferentStoreModel, setTransferToDifferentStoreModel] = useState(false);

  const [showModal, setShowModel] = useState(false);
  const [showChantoOnDemandModel, setShowChantoOnDemandModel] = useState(false)
  const [showTransferToOnFleetModel, setShowTransferToOnFleetModel] = useState(false)
  const [showDeliveredConfirm, setShowDeliveredConfirm] = useState(false);
  const [isMarkingDelivered, setIsMarkingDelivered] = useState(false);
  const [to, setTo] = useState(1);
  const config = useContext(OrderConfigContext);
  const { showToastMessage, setIsLoading, modules, lastOrderEditPath } = useContext(AppContext);
  const [access, setAccess] = useState({});
  const { duplicateOrder, replaceOrder } = useOrder();


  useEffect(getModuleAccess, [modules]);


  function getModuleAccess() {
    let access = getAccessByModuleName(modules, MODULES.VIEW_ORDER);
    if (access) setAccess(access.permissions);
    if (access && !access.permissions.read_access) {
      showToastMessage(
        undefined,
        "You are not authorized to access.",
        "error",
        false
      );
      navigate(`/users`);
    }
  }

  useEffect(() => {
    let viewOrderAccess = getAccessByModuleName(modules, MODULES.VIEW_ORDER);
    if (viewOrderAccess && viewOrderAccess.permissions.read_access) {
      handleGetOrderDetails();
      handleGetDeliveryTypes();
      handleGetFrequency();
    }
  }, [id]);

  const handleGetOrderDetails = async () => {
    if (!id) return;

    setIsLoading(true);
    const response = await getOrderDetailsById(id);

    if (response && response.status === 200) {
      setOrderDetails(response.data.data);
    } else {
      showToastMessage(undefined, response.data.message, "error", false);
    }
    setIsLoading(false);
  };

  const handleUnfraudorder = async () => {
    if (!id) return;

    setIsLoading(true);
    let postData = {
      "order_id": id
    }
    const response = await unsetFraudOrder(postData);

    if (response && response.status === 200) {
      navigate(lastOrderEditPath)
      showToastMessage(undefined, response.data.message, "success", false);
    } else {
      showToastMessage(undefined, response.data.message, "error", false);
    }
    setIsLoading(false);
  };

  const handleGetDeliveryTypes = async () => {
    let PostData = {
      sortBy: [
        {
          id: "id",
          desc: false,
        },
      ],
    };
    const response = await getDeliveryTypes(PostData);

    if (response && response.status === 200) {
      setDeliveryTypesList(response.data.data.rows);
    } else {
      showToastMessage(undefined, response.data.message, "error", false);
    }
  };

  const handleGetFrequency = async () => {
    const response = await getFrequnceyList();
    if (response.status === 200) {
      let freqData = [];
      for (let k in response.data.data) {
        let freDataobj = {
          name: response.data.data[k],
          id: +k,
        };
        freqData.push(freDataobj);
      }
      setFrequencyList(freqData);
    }
  };

  const handleDownloadReceipt = async (event) => {
    event.preventDefault();

    if (!orderDetails?.id || isDownloadingReceipt) return;

    setIsDownloadingReceipt(true);

    try {
      await downloadOrderReceiptPdf(orderDetails);
    } catch {
      showToastMessage(
        undefined,
        "Unable to create the receipt PDF. Please try again.",
        "error",
        false
      );
    } finally {
      setIsDownloadingReceipt(false);
    }
  };

  const [tabId, setTabId] = React.useState(0);
  const handleTabChange = (event, newTabId) => {
    setTabId(newTabId);
  };

  const greetingCardRePrint = async (event) => {
    event.preventDefault();
    let recipientId = orderDetails?.order_recipients[tabId]?.id;
    let orderId = orderDetails?.id;

    let PostData = {
      order_id: orderId,
      recipient_id: recipientId,
    };
    setIsLoading(true);
    try {
      const response = await printGreetingMessage(PostData);

      if (response && response.status === 200) {
        if (!openPrintMessage(response.data.data)) {
          showToastMessage(undefined, "Unable to open the PDF. Please allow pop-ups and try again.", "error", false);
        }
      } else {
        showToastMessage(undefined, response.data.message, "error", false);
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      showToastMessage(undefined, error.response?.data?.message, "error", false);
    }
  };

  const openMailSendPopup = async (event, emailType = "confirmation") => {
    event.preventDefault();
    setResendEmailType(emailType);
    setShowAddModal(true);
  };

  const orderMailReSend = async (email) => {
    let orderId = orderDetails?.id;

    const emailValidate = checkValidEmailId(String(email).toLowerCase());

    if (emailValidate) {
      setIsLoading(true);
      try {
        let postData = {
          emailId: email,
          orderId: orderId,
          emailType: resendEmailType,
        };

        const response = await orderMailSend(postData);

        if (response && response.status === 200) {
          showToastMessage(undefined, response.data.message, "success", false);
        } else {
          showToastMessage(undefined, response.data.message, "error", false);
        }
        setIsLoading(false);
      } catch (error) {
        setIsLoading(false);
        showToastMessage(
          undefined,
          error.response.data.message,
          "error",
          false
        );
      }
      setShowAddModal(false);
    } else {
      showToastMessage(
        undefined,
        "Please enter valid email id",
        "error",
        false
      );
    }
  };

  const getAddressLabel = (selectedText) => {
    let addressLabel = {};
    let attnLabel = "Attention";
    let addressLine2Label = "Address Line 2";

    if (selectedText) {
      if (selectedText.toLowerCase() === "house") attnLabel = "Attention";
      else if (selectedText.toLowerCase() === "apartment") {
        attnLabel = "Apartment Name";
        addressLine2Label = "Unit Number";
      } else if (selectedText.toLowerCase() === "business") {
        attnLabel = "Business Name";
        addressLine2Label = "Floor/suite Number";
      } else if (selectedText.toLowerCase() === "funeral home")
        attnLabel = "Funeralhome Name";
      else if (selectedText.toLowerCase() === "church")
        attnLabel = "Church Name";
      else if (selectedText.toLowerCase() === "hospital") {
        attnLabel = "Hospital Name";
        addressLine2Label = "Room Number";
      } else if (selectedText.toLowerCase() === "restaurant")
        attnLabel = "Restaurant Name";
      else if (selectedText.toLowerCase() === "hotel") {
        attnLabel = "Hotel Name";
        addressLine2Label = "Room Number";
      } else if (selectedText.toLowerCase() === "university") {
        attnLabel = "School Name";
        addressLine2Label = "Dorm Info";
      } else if (selectedText.toLowerCase() === "other school") {
        attnLabel = "Other School";
        addressLine2Label = "Room Number";
      }
    }

    addressLabel = {
      attnLabel: attnLabel,
      addressLine2Label: addressLine2Label,
    };
    return addressLabel;
  };

  const getKeyByValue = (objectData, value) => {
    let deliveryData = objectData.find((optionsObj) => optionsObj.id === value);
    return deliveryData ? deliveryData.name : "-";
  };

  let orderErrors = useMemo(() => {
    let order_validation = orderDetails?.order_validations?.map((data) => {
      return {
        id: data.id ?? 0,
        order_id: data.order_id ?? 0,
        validation_type: data.validation_type ?? "",
        validation_message: data.validation_message ?? "",
        validation_status: data.validation_status ?? 0,
        updated_by: data.updated_by ?? 0,
      };
    });
    let orderErrors = order_validation?.map((data) => {
      let error = data.validation_message;
      return { error };
    });
    if (!orderDetails?.is_local_order && !orderDetails?.order_type) {
      orderErrors = orderErrors || [];
      orderErrors.push({ error: "Not a local order" });
    }
    return orderErrors;
  }, [orderDetails]);

  let delivery_time = React.useMemo(() => {
    if (orderDetails.delivery_time_type === "Anytime") {
      return orderDetails.delivery_time_type;
    } else {
      return `${orderDetails.delivery_time_type} ${convertDateTime(orderDetails.delivery_date_time, 'iso', "hh:mm a")}`;
    }
  }, [orderDetails]);

  let internalNotesdata = orderDetails?.order_internal_notes?.map(
    (note) => {
      let notesData = {
        author: formatInternalNoteAuthor(note),
        time: note.createdAt,
        ans: note.notes,
      };
      return notesData;
    }
  );

  const validateTransferStoreOrder = (orderDetails, toStoreId = 0) => {
    const fromStoreId = orderDetails?.store_id ?? 0;
    const fromStore = PAYMENT_METHOD_DETAIL[fromStoreId] ? PAYMENT_METHOD_DETAIL[fromStoreId] : PAYMENT_METHODS.PAYABLI;
    const toStore = PAYMENT_METHOD_DETAIL[toStoreId] ? PAYMENT_METHOD_DETAIL[toStoreId] : PAYMENT_METHODS.PAYABLI;

    if (fromStore === PAYMENT_METHODS.BRAINTREE &&
      toStore === PAYMENT_METHODS.BRAINTREE) {
      return false;
    } else if (fromStore === PAYMENT_METHODS.BRAINTREE &&
      toStore === PAYMENT_METHODS.PAYABLI) {
      return true;
    } else if (fromStore === PAYMENT_METHODS.PAYABLI &&
      toStore === PAYMENT_METHODS.BRAINTREE) {
      return true;
    } else {
      if (fromStore === PAYMENT_METHODS.PAYABLI &&
        toStore === PAYMENT_METHODS.PAYABLI) {
        return false;
      }
    }
    return false;
  }

  const HandleTransferStore = async (e) => {
    e.preventDefault();
    const isValidateTransferStoreOrder = validateTransferStoreOrder(orderDetails, to);
    if (isValidateTransferStoreOrder) {
      showToastMessage(undefined, "Sorry you can't transter this order", "error", false);
      setShowModel(false);
      return;
    }
    if (orderDetails.store.id === to) {
      showToastMessage(
        undefined,
        "You can not select same store",
        "error",
        false
      );
    } else {
      setIsLoading(true);
      const postData = {
        order_id: orderDetails.id,
        store_id: to
      }
      const response = await transferToDifferentStore(postData)
      if (response && response.status === 200) {
        setTo(1)
        showToastMessage(undefined, response.data.message, "success", false);
        setIsLoading(false);
        setShowModel(false);
        navigate("/admin/orders/list");
      } else {
        showToastMessage(undefined, response.data.message, "error", false);
      }
      setIsLoading(false);
    }
  }
  let order_status = ["pending", "processing", "in_design", "design_completed", "cancel", "failed"]
  const HandleChangeOndemandOrder = async (e) => {
    e.preventDefault();
    setShowChantoOnDemandModel(false)
  }

  const order_payment_transactions = orderDetails?.order_transaction?.order_payment_transactions?.filter((val) => val.order_id === 0)
  // Details not loaded yet -> unsupported, unlike an empty, loaded list.
  const refund_supported = order_payment_transactions && isRefundSupported(order_payment_transactions[0])

  const editOrderAccess = getAccessByModuleName(modules, MODULES.EDIT_ORDER);
  // Same orders the Admin Delivered route covers, Onfleet task or not.
  const canMarkDelivered =
    editOrderAccess?.permissions.write_access &&
    !["delivered", "cancel", "failed"].includes(orderDetails?.order_status) &&
    !orderDetails?.refund &&
    orderDetails?.order_type == 0;

  const handleMarkDelivered = async (e) => {
    e.preventDefault();
    if (isMarkingDelivered) return;
    setIsMarkingDelivered(true);
    const body = { order_id: orderDetails.id, order_status: "delivered" };
    try {
      await (orderDetails.is_burq_order == 1 ? updateBurqOrder(body) : updateOnfleetOrder(body));
      showToastMessage(undefined, `Order ${orderDetails.order_number} is delivered.`, "success", false);
      setShowDeliveredConfirm(false);
      handleGetOrderDetails();
    } catch (error) {
      showToastMessage(undefined, error?.response?.data?.message || "The order was not marked delivered.", "error", false);
    }
    setIsMarkingDelivered(false);
  };


  return (
    <React.Fragment>
      <Header title="View Order" hasUnFraudOrderButton={orderDetails.is_fraud_order} handleUnFraudOrderClick={handleUnfraudorder} />
      {transferToDifferentStoreModel && (
        <Confirmation
          showModal={transferToDifferentStoreModel}
          title="Confirm Order Transfer"
          descriptionClass={styles.transferToDifferentStoreDescription}
          message={`
            This action transfers the order to the new store. Sales tax is recalculated: a lower tax refunds the customer the difference, a higher tax is absorbed by the new store and the customer pays nothing more.
          `}
          btn1_title="Confirm"
          btn2_title="Cancel"
          handleCancelClick={(e) => {
            e.preventDefault();
            setTransferToDifferentStoreModel(false);
            setShowModel(false);
            setTo(1);
          }}
          key="confirmation-transfer-order"
          handleSubmitClick={(e)=>{
            setTransferToDifferentStoreModel(false);
            HandleTransferStore(e);
          }}
        />
      )}
      {showModal ?
        <TransferToDifferentStore
          to={to}
          showModal={showModal}
          options={config.storeList}
          from={orderDetails.store.title}
          pageTitle="Order Transfer to Different Store"
          handleSubmitClick={(e) => {
            e.preventDefault();
            setTransferToDifferentStoreModel(true)
          }}

          handleCancelClick={(e) => {
            e.preventDefault();
            setShowModel(false);
            setTo(1);
          }}
          onChange={(type, data) => { if (type === "store") setTo(data); }}
        />: ""
      }
      {
        showChantoOnDemandModel ?
          <ChangetoOnDemand
            showModal={showChantoOnDemandModel}
            pageTitle={"Change to OnDemand Order"}
            handleCancelClick={() => { setShowChantoOnDemandModel(false) }}
            handleSubmitClick={HandleChangeOndemandOrder}
            orderDetails={orderDetails}
            close={setShowChantoOnDemandModel}
          />
          : ""
      }

      {showTransferToOnFleetModel && (
        <TransferToOnFleetModal
          showModal={ showTransferToOnFleetModel }
          pageTitle={"Transfer to Onfleet Order"}
          handleCancelClick={() => setShowTransferToOnFleetModel(false)}
          handleSubmitClick={()=>{}}
          orderDetails={orderDetails}
          close={setShowTransferToOnFleetModel}
        />
      )}
      <button
        onClick={(e) => {
          e.preventDefault();
          navigate(`/admin/orders/edit/${orderDetails?.id}`);
        }}
        className="btn pink-btn actionBtn"
      >
        Edit order
      </button>
      <button
        onClick={handleDownloadReceipt}
        className="btn pink-btn pl-2 pr-2 ml-2 actionBtn"
        disabled={!orderDetails?.id || isDownloadingReceipt}
      >
        {isDownloadingReceipt ? "Creating PDF..." : "Print Receipt"}
      </button>
      {canMarkDelivered && (
        <button
          onClick={() => setShowDeliveredConfirm(true)}
          disabled={isMarkingDelivered}
          className="btn pink-btn pl-2 pr-2 ml-2 actionBtn"
        >
          {isMarkingDelivered ? "Marking delivered..." : "Mark as Delivered"}
        </button>
      )}
      <Confirmation
        showModal={showDeliveredConfirm}
        title="Mark this order delivered?"
        message={`The delivery email goes to the customer and the status cannot be put back. Only do this when order ${orderDetails?.order_number} has been delivered.`}
        btn1_title={isMarkingDelivered ? "Marking delivered..." : "Mark Delivered"}
        btn2_title="Cancel"
        handleSubmitClick={handleMarkDelivered}
        handleCancelClick={() => setShowDeliveredConfirm(false)}
      />
      {orderDetails?.source !== ORDER_SOURCE.WALKIN.toLowerCase() &&
        refund_supported &&
        <button
          onClick={() => {
            setShowModel(true)
          }}
          className="btn pink-btn pl-2 pr-2 ml-2 actionBtn"
        >
          Transfer to different store
        </button>
      }
      
      {(orderDetails.is_burq_order &&
        orderDetails.order_type == 0 &&
        ONDEMAND_TRANSFER_DELIVERY_TYPE_IDS.includes(Number(orderDetails.delivery_type_id))) &&
        order_status.includes(orderDetails.order_status) ? (
        <button
          onClick={() => {
            setShowTransferToOnFleetModel(true)
          }}
          className="btn pink-btn pl-2 pr-2 ml-2 actionBtn">
          Transfer to Onfleet
        </button>
      ):""}

      {(orderDetails.is_burq_order !== 1 &&
        orderDetails.order_type == 0 &&
        ONDEMAND_TRANSFER_DELIVERY_TYPE_IDS.includes(Number(orderDetails.delivery_type_id))) &&
        order_status.includes(orderDetails.order_status) ?
        <button
          onClick={() => {
            setShowChantoOnDemandModel(true)
          }}
          className="btn pink-btn pl-2 pr-2 ml-2 actionBtn">
          Change to OnDemand
        </button> : ""}
      {orderDetails &&
        orderDetails.order_status === "cancel" &&
        !orderDetails.is_fraud_order &&
        orderDetails.reason_for_cancellation ? (
        <OrderReason
          title={"Reason for the cancellation."}
          reason={orderDetails.reason_for_cancellation}
        />
      ) : (
        ""
      )}


      {orderDetails &&
        orderDetails.is_fraud_order &&
        orderDetails.reason_for_cancellation ? (
        <OrderReason
          title={`Reason for the ${orderDetails?.order_status === "cancel" ? "Cancellation/" : ""
            }Fraud Order`}
          reason={orderDetails.reason_for_cancellation}
        />
      ) : (
        ""
      )}

      {orderErrors && orderErrors.length !== 0 && (
        <OrderError errors={orderErrors} />
      )}

      <div id="MainContent" className="main-content">
        <div className="container-fluid order-container">
          <OrderSummery
            orderNumber={
              <>
                {orderDetails.order_number}
                {orderDetails.order_type_identifier > 0 && (
                  <Link className="link d-block" to={`/admin/orders/view/${orderDetails.parent_order_id}`}>
                    View parent order
                  </Link>
                )}
              </>
            }
            orderDate={orderDetails.createdAt}
            deliveryDate={orderDetails.delivery_date_time}
            delivery_time={delivery_time}
            deliveryStatus={
              orderDetails.order_status
                ? ORDER_STATUS[orderDetails.order_status.toUpperCase()]
                : "-"
            }
            timeDelivered={
              orderDetails && orderDetails.order_status === "delivered"
                ? orderDetails.actual_order_delivered_time
                : null
            }
            takenBy={
              orderDetails.csr_id && orderDetails.csr_detail
                ? orderDetails.csr_detail.full_name
                : orderDetails.created_by && orderDetails.created_detail
                  ? orderDetails.created_detail.full_name
                  : "-"
            }
            designedBy={
              orderDetails.designer_id && orderDetails.designer_detail
                ? orderDetails.designer_detail.full_name
                : "-"
            }
            driverName={
              orderDetails.driver_name ? orderDetails.driver_name : "-"
            }
            onfleetTaskId={
              orderDetails.onfleet_task_id ? orderDetails.onfleet_task_id : null
            }
            isBurqOrder={orderDetails.is_burq_order}
            burqOrderId={
              orderDetails.burq_order_id ? orderDetails.burq_order_id : null
            }
            signature={
              orderDetails.recipient_signature_or_picture
                ? orderDetails.recipient_signature_or_picture
                : defaultSignature
            }
            source={
              orderDetails.source
                ? ORDER_SOURCE[orderDetails.source.toUpperCase()]
                : "-"
            }
            deliveringStore={orderDetails?.store}
            orderCompletedImages={orderDetails?.order_completed_images}
          />

          {orderDetails && orderDetails.klaviyo_segments ? (
            <div className="d-md-flex align-items-md-center flex-wrap mt-4">
              <span className="bold mr-2">Customer Segments:</span>
              <SegmentBadge segments={orderDetails.klaviyo_segments} />
            </div>
          ) : null}

          <div className="d-md-flex align-items-md-center mt-5 mb-4">
            <h3 className="bold">
              Recipient Information
              <span className={`ml-1 mr-5`} />
            </h3>
            <Tabs
              value={tabId}
              onChange={handleTabChange}
              className="tabBorderDesign"
              style={{ 
                borderBottom: "1px solid #f2f3f5",
                maxWidth: "100%",
                overflowX: "auto",
                scrollbarWidth: "thin",
              }}
              indicatorColor="primary"
              textColor="primary"
              variant="scrollable"
              scrollButtons="auto"
            >
              {orderDetails &&
                orderDetails.order_recipients &&
                orderDetails.order_recipients.map((recipient, index) => {
                  return (
                    <Tab
                      key={index}
                      id={index}
                      label={`Recipient ${index + 1}`}
                      
                    />
                  );
                })}
            </Tabs>
          </div>

          {orderDetails &&
            orderDetails.order_recipients &&
            orderDetails.order_recipients.map((recipient, index) => {
              let addressLabel = getAddressLabel(recipient.address_type);
              recipient["attnLabel"] = addressLabel["attnLabel"];
              recipient["addressLine2Label"] =
                addressLabel["addressLine2Label"];
              return (
                <TabPanel tabId={tabId} index={index}>
                  <RecipentForm recipientData={recipient} index={index} />
                </TabPanel>
              );
            })}

          <h3 className="bold mt-5">Driver Instructions</h3>
          <div className={`row`}>
            <div className={`col-md-12 col-xs-12`}>
              <TextArea
                label="Driver Instructions"
                rows={3}
                value={
                  orderDetails.driver_instruction
                    ? orderDetails.driver_instruction
                    : "-"
                }
                disabled={true}
              />
            </div>
            <div className={`col-md-5 col-xs-12`}>
              <RadioBox
                labelClass={styles.deliveryMatrixFormRadioLabel}
                label="Delivery Order"
                value={false}
                selectedValue={orderDetails.order_type}
                disabled={true}
              />
              <RadioBox
                label="Pickup Order"
                labelClass={styles.deliveryMatrixFormRadioLabel}
                value={true}
                selectedValue={orderDetails.order_type}
                disabled={true}
              />
            </div>
            {
              orderDetails.order_type ?
                <div className={`col-md-4 col-xs-12 store`}>
                  <Text
                    label="Select Store"
                    value={orderDetails.store.title}
                    type="text"
                    disabled={true}
                  />
                </div> : <div className="col-4"></div>
            }

            <div className={`col-md-4 col-xs-12`}>
              <Text
                type="text"
                label={
                  orderDetails.order_type === false
                    ? "Delivery Date"
                    : "Pickup Date"
                }
                value={
                  orderDetails.delivery_date_time &&
                    orderDetails.delivery_date_time !== null
                    ? convertDateTime(orderDetails.delivery_date_time, 'iso', "ccc LLL dd, yyyy")
                    : "-"
                }
                disabled={true}
              />
            </div>
            <div className={`col-md-4 col-xs-12`}>
              <Text
                type="text"
                label="Delivery Type"
                value={
                  orderDetails.delivery_type_id &&
                    orderDetails.delivery_type_id > 0
                    ? getKeyByValue(
                      deliveryTypesList,
                      orderDetails.delivery_type_id
                    )
                    : "-"
                }
                disabled={true}
              />
            </div>
            <div className={`col-md-4 col-xs-12`}>
              <Text
                type="text"
                label={
                  orderDetails.order_type === false
                    ? "Delivery Time"
                    : "Pickup Time"
                }
                value={
                  orderDetails.is_custom_delivery_matrix === 1
                    ? "Custom"
                    : delivery_time
                      ? delivery_time
                      : "-"
                }
                disabled={true}
              />
            </div>
            {orderDetails?.is_custom_delivery_matrix === 1 && (
              <>
                <div className={`col-md-4 col-xs-12`}>
                  <Text
                    type="text"
                    label={"Delivery Time"}
                    value={delivery_time ? delivery_time : "-"}
                    disabled={true}
                  />
                </div>
                <div className={`col-md-4 col-xs-12`}>
                  <Text
                    type="text"
                    label={"Delivery Charge"}
                    value={
                      orderDetails.delivery_charges
                        ? `$${orderDetails.delivery_charges}`
                        : "-"
                    }
                    disabled={true}
                  />
                </div>
              </>
            )}
            {orderDetails.is_subscribe_order && (
              <div className={`col-md-4 col-xs-12`}>
                <Text
                  type="text"
                  label="Subscription Type"
                  value={
                    orderDetails.subscription_order &&
                      orderDetails.subscription_order.frequency
                      ? getKeyByValue(
                        frequencyList,
                        orderDetails.subscription_order.frequency
                      )
                      : "-"
                  }
                  disabled={true}
                />
              </div>
            )}

            {orderDetails && orderDetails.shopcode ? (
              <div className={`col-md-4 col-xs-12`}>
                <Text
                  type="text"
                  label="Shop Code"
                  value={orderDetails.shopcode ? orderDetails.shopcode : "-"}
                  disabled={true}
                />
              </div>
            ) : (
              ""
            )}
            {orderDetails && orderDetails.external_shop_name ? (
              <div className={`col-md-4 col-xs-12`}>
                <Text
                  type="text"
                  label="Shop Name"
                  value={
                    orderDetails.external_shop_name
                      ? orderDetails.external_shop_name
                      : "-"
                  }
                  disabled={true}
                />
              </div>
            ) : (
              ""
            )}
            {orderDetails && orderDetails.external_person_name ? (
              <div className={`col-md-4 col-xs-12`}>
                <Text
                  type="text"
                  label="Person Name"
                  value={
                    orderDetails.external_person_name
                      ? orderDetails.external_person_name
                      : "-"
                  }
                  disabled={true}
                />
              </div>
            ) : (
              ""
            )}
            {orderDetails && orderDetails.external_order_number ? (
              <div className={`col-md-4 col-xs-12`}>
                <Text
                  type="text"
                  label="External Order Number"
                  value={
                    orderDetails.external_order_number
                      ? orderDetails.external_order_number
                      : "-"
                  }
                  disabled={true}
                />
              </div>
            ) : (
              ""
            )}
            {orderDetails && orderDetails.external_phone_number ? (
              <div className={`col-md-4 col-xs-12`}>
                <Text
                  type="text"
                  label="Phone Number"
                  value={
                    orderDetails.external_phone_number
                      ? formatUsPhone(orderDetails.external_phone_number)
                      : "-"
                  }
                  disabled={true}
                />
              </div>
            ) : (
              ""
            )}
          </div>

          {orderDetails &&
            orderDetails.order_recipients &&
            orderDetails.order_recipients.map((recipient, index) => {
              return (
                <TabPanel tabId={tabId} index={index}>
                  <div className={`row`}>
                    <div className={`col-md-6 col-xs-12`}>
                      <h3 className="bold mt-5 mb-4">Greetings On The Card</h3>
                      {recipient.greetings_on_card ? (
                        <GreetingCard
                          rows={5}
                          value={recipient.greetings_on_card}
                          disabled={true}
                          signature={
                            recipient.card_signature
                              ? recipient.card_signature
                              : ""
                          }
                          video_url={recipient.video_url}
                        />
                      ) : (
                        "-"
                      )}
                      <div className="mt-3">
                        <Text
                          type="text"
                          label="Card Signature"
                          value={
                            recipient.card_signature
                              ? recipient.card_signature
                              : "-"
                          }
                          disabled={true}
                        />
                      </div>
                    </div>
                    {recipient.video_message || recipient.video_url ? (
                      <div className={`col-md-6 col-xs-12`}>
                        <h3 className="bold mt-5 mb-4">Video Message</h3>
                        <VideoMessage
                          URL={recipient.video_url}
                          message={recipient.video_message}
                        />
                      </div>
                    ) : (
                      "-"
                    )}
                  </div>
                </TabPanel>
              );
            })}

          {orderDetails &&
            orderDetails.order_recipients &&
            orderDetails.order_recipients.map((recipient, index) => {
              let productsData = recipient.order_products.filter(
                (product) => product.product_type === false
              );
              let addonsData = recipient.order_products.filter(
                (product) => product.product_type === true
              );
              return (
                <TabPanel tabId={tabId} index={index}>
                  <div className={`row`}>
                    <div className={`col-md-6 col-xs-12 mt-5 mb-4`}>
                      <OrderProducts
                        title={"Products"}
                        itemData={productsData}
                      />
                    </div>

                    <div className={`col-md-6 col-xs-12 mt-5 mb-4`}>
                      <OrderProducts title={"Add Ons"} itemData={addonsData} />
                    </div>
                  </div>
                </TabPanel>
              );
            })}

          <h3 className="bold mt-5">Designer Instructions</h3>
          <div className={`row`}>
            <div className={`col-md-12 col-xs-12`}>
              <TextArea
                label="Designer Instructions"
                rows={3}
                value={
                  orderDetails.designer_instruction
                    ? orderDetails.designer_instruction
                    : "-"
                }
                disabled={true}
              />
            </div>
          </div>

          <div className={`row`}>
            <div className={`col-md-8 col-xs-12`}>
              <h3 className="bold mt-5 mb-4">Payment Types</h3>
              <div className={`row`}>
                <div className={`col-md-6 col-xs-12`}>
                  <div className={`row`}>
                    <div className={`col-md-8`}>
                      {orderDetails && orderDetails.order_transaction ? (
                        <Text
                          type="text"
                          label="Payment Type"
                          value={
                            orderDetails.order_transaction
                              ?.order_payment_transactions[0]?.transaction_type
                              ? PAYMENT_TYPE[
                              orderDetails.order_transaction?.order_payment_transactions[0]?.transaction_type?.toUpperCase()
                              ]
                              : "-"
                          }
                          disabled={true}
                        />
                      ) : (
                        ""
                      )}
                    </div>
                    <div className={`col-md-4`}></div>
                  </div>
                  {orderDetails && orderDetails.order_transaction ? (
                    <CardInfoSaved
                      tr_type={
                        orderDetails.order_transaction
                          ?.order_payment_transactions[0]?.transaction_type
                      }
                      card_last_4_digits={
                        orderDetails.order_transaction
                          .order_payment_transactions[0]?.card_last_4_digits
                      }
                      card_type={
                        orderDetails.order_transaction
                          .order_payment_transactions[0]?.card_type
                      }
                      isViewOrder={true}
                    />
                  ) : (
                    ""
                  )}
                </div>
                <div className={`col-md-6 col-xs-12`}>
                  <TotalBox orderData={orderDetails} />
                </div>
              </div>
            </div>

            <div className={`col-md-4 col-xs-12`}>
              <h3 className="bold mt-5 mb-4">Internal Notes</h3>
              <Internotes
                data={internalNotesdata}
                isViewOrder={true}
                isEdit={false}
              />
            </div>
          </div>
          {orderDetails && orderDetails?.source !== ORDER_SOURCE.WALKIN.toLowerCase() && (
            <>
              <h3 className="bold mt-5 mb-4">Billing Information</h3>
              {orderDetails && orderDetails.order_transaction ? (
                <BillingForm billingData={orderDetails.order_transaction} />
              ) : (
                ""
              )}
              <h3 className="bold mt-5 mb-4">Customer Information</h3>
              {orderDetails && orderDetails.order_transaction ? (
                <CoustumerForm coustumerData={orderDetails.order_transaction} />
              ) : (
                ""
              )}
            </>
          )}
        </div>
      </div>
      <div className="col-md-12" style={{ "margin-bottom": "100px" }}>
        <button
          onClick={greetingCardRePrint}
          className={`btn pink-btn`}
          style={{ float: "right" }}
        >
          Reprint Greeting Card
        </button>

        <button
          onClick={(e) => openMailSendPopup(e, "delivered")}
          className={`btn pink-btn mr-2`}
          style={{ float: "right" }}
        >
          Resend Delivered Email
        </button>
        <button
          onClick={(e) => openMailSendPopup(e, "confirmation")}
          className={`btn pink-btn mr-2`}
          style={{ float: "right" }}
        >
          Resend Confirmation Email
        </button>
      </div>

      <EmailReSendMail
        showModal={showAddModal}
        pageTitle={resendEmailType === "delivered" ? "Resend Delivered Email" : "Resend Confirmation Email"}
        email={orderDetails?.order_transaction?.customer_email}
        handleCancelClick={(e) => {
          setShowAddModal(false);
        }}
        submitStatus={submitStatus}
        handleSubmitClick={orderMailReSend}
      />
    </React.Fragment>
  );
};

// A new :id keeps the same route element, so key it to reset tab, modal and fetch state.
const ViewOrderById = () => <ViewOrder key={useParams().id} />;
export default ViewOrderById;

function TabPanel(props) {
  const { children, tabId, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={tabId !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {tabId === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}
